import i18next from 'i18next'
import { FavouriteShotEnum } from 'types/api/enums'
import { CoreFieldKeyApi } from 'types/global'

export enum CoreFieldsMapping {
  isSexUpdateable = 'sex',
  isBirthDateUpdateable = 'birthDate',
  isNationalityUpdateable = 'nationalityCode',
  isNativeGivenNameUpdateable = 'nativeGivenName',
  isNativeFamilyNameUpdateable = 'nativeFamilyName',
  isCountryOfResidenceUpdateable = 'countryOfResidenceCode',
}

export type CoreFieldKey = `${CoreFieldKeyApi}`

export const EDITABLE_BIOGRAPHICAL_FIELDS = [
  'heightInMeters',
  'favouriteShot',
  'playingHand',
  'doublePlayingHand',
]

export const getFavouriteShotFromEnum = (favouriteShot: FavouriteShotEnum): string => {
  switch (favouriteShot) {
    case FavouriteShotEnum.FOREHAND:
      return i18next.t('optsFavouriteShotForehand', { ns: 'strEditProfile' })

    case FavouriteShotEnum.BACKHAND:
      return i18next.t('optsFavouriteShotBackhand', { ns: 'strEditProfile' })

    case FavouriteShotEnum.SERVE:
      return i18next.t('optsFavouriteShotServe', { ns: 'strEditProfile' })

    case FavouriteShotEnum.VOLLEY:
      return i18next.t('optsFavouriteShotVolley', { ns: 'strEditProfile' })

    case FavouriteShotEnum.SMASH:
      return i18next.t('optsFavouriteShotSmash', { ns: 'strEditProfile' })

    case FavouriteShotEnum.DROPSHOT:
      return i18next.t('optsFavouriteShotDropShot', { ns: 'strEditProfile' })

    default:
      return ''
  }
}

export const getFavouriteShotOptions = () => [
  {
    value: FavouriteShotEnum.FOREHAND,
    label: getFavouriteShotFromEnum(FavouriteShotEnum.FOREHAND),
  },
  {
    value: FavouriteShotEnum.BACKHAND,
    label: getFavouriteShotFromEnum(FavouriteShotEnum.BACKHAND),
  },
  {
    value: FavouriteShotEnum.SERVE,
    label: getFavouriteShotFromEnum(FavouriteShotEnum.SERVE),
  },
  {
    value: FavouriteShotEnum.VOLLEY,
    label: getFavouriteShotFromEnum(FavouriteShotEnum.VOLLEY),
  },
  {
    value: FavouriteShotEnum.SMASH,
    label: getFavouriteShotFromEnum(FavouriteShotEnum.SMASH),
  },
  {
    value: FavouriteShotEnum.DROPSHOT,
    label: getFavouriteShotFromEnum(FavouriteShotEnum.DROPSHOT),
  },
]

export enum UnitSystem {
  METRIC = 'Metric',
  IMPERIAL = 'Imperial',
}

export const getHeightUnitOptions = () => [
  { name: i18next.t('inputMetric', { ns: 'strEditProfile' }), key: UnitSystem.METRIC },
  { name: i18next.t('inputImperial', { ns: 'strEditProfile' }), key: UnitSystem.IMPERIAL },
]

export enum FormValidationErrors {
  INVALID_RESIDENCE_CODE = 'INVALID_RESIDENCE_CODE',
}
